import decorationMobx from '../mobx/app/decoration.mobx'
import { mallMobx } from '@mobx/mall'
import { restaurantConfig } from 'restaurant'
import { MallStyleController } from '@ctrls/mallController'
import productStyleController from './productStyleController'

class ScrollController {
  static isScrolling = false
  static _top: number = 0
  private static _type: string = ''
  private static mainHeight = 0
  private static ionTabbar = null
  private static productOffTop = 0
  private static contentHeight = 0
  static reset () {
    this.mainHeight = 0
    this.productOffTop = 0
    this._top = 0
    decorationMobx.setSearchBarVisible(false)
  }
  private static forbidSearchBar = false
  static handScroll (scrollTop: number, type: '#allMenuWarp' | '.choose-store-content' | '#MallWarp') {
    // const scrollTop = e.detail.scrollTop
    if (type !== this._type) {
      this._type = type
      // this.mainHeight = document.querySelector(type)?.clientHeight || 0
    }
    // if (!this.mainHeight) {
    this.mainHeight = document.querySelector(type)?.clientHeight || 0
    // }
    if (!this.ionTabbar) {
      this.ionTabbar = document.querySelector('ion-tab-bar')
    }
    if (!this.productOffTop && type === '#allMenuWarp') {
      this.productOffTop = (document.querySelector('.product-template') as any)?.offsetTop || 0
    }
    if (!this.ionTabbar) {
      return true
    }
    if (!this.contentHeight) {
      this.contentHeight = document.body.offsetHeight
    }
    // 边界不处理
    if (scrollTop < 0 || this.mainHeight === 0 || scrollTop + this.contentHeight >= this.mainHeight) {
      return true
    }
    // 滚动距离少于5px不处理
    if (Math.abs(scrollTop - this._top) < 5) {
      return true
    }
    // 点餐页其他连带滚动
    if (type === '#allMenuWarp') {
      decorationMobx.setMenuScrollTop(scrollTop)
      // 桥接到controller处理图片延迟滚动加载
      productStyleController.scroll(scrollTop)
    }
    if (scrollTop > this._top && ((120 + scrollTop + this.contentHeight) > this.mainHeight)) {
      if (!decorationMobx.tabBarVisible) {
        decorationMobx.setTabBarVisible(true)
        this.ionTabbar?.classList.remove('hide')
      }
    } else if (scrollTop > this._top) {
      if (decorationMobx.tabBarVisible) {
        decorationMobx.setTabBarVisible(false)
        this.ionTabbar?.classList.add('hide')
      }
    } else if (scrollTop < this._top) {
      if (!decorationMobx.tabBarVisible) {
        decorationMobx.setTabBarVisible(true)
        this.ionTabbar?.classList.remove('hide')
      }
    }

    // 点餐页其他连带滚动
    if (type === '#MallWarp') {
      // 桥接到controller处理图片延迟滚动加载
      mallMobx.setMallScrollTop(scrollTop)
      // MallStyleController.scroll(scrollTop)
      MallStyleController.scroll(scrollTop)
    }
    if (type === '#allMenuWarp') {
      // this.productOffTop -
      const pOffTop = this.productOffTop > 160 ? this.productOffTop - 80 : 80
      if (this.forbidSearchBar) {
        decorationMobx.setSearchBarVisible(false)
      } else if (scrollTop < 5) {
        decorationMobx.setSearchBarVisible(false)
      } else if (scrollTop <= pOffTop) {
        decorationMobx.setSearchBarVisible(false)
      } else {
        if (restaurantConfig.displayMode === 'waterfall') {
          decorationMobx.setSearchBarVisible(true)
        } else {
          if (scrollTop > this._top) {
            decorationMobx.setSearchBarVisible(false)
          } else if (scrollTop < this._top) {
            decorationMobx.setSearchBarVisible(true)
          }
        }
      }
      if (scrollTop >= this.productOffTop - 56 + 48) {
        decorationMobx.setHeaderCategoryBarVisible(true)
      } else {
        decorationMobx.setHeaderCategoryBarVisible(false)
      }
    }
    this._top = scrollTop
  }
  static setForbidSearchBar (value: boolean) {
    this.forbidSearchBar = value
  }
}

export default ScrollController
